// PREVIEW-ONLY signed-in homepage intro. Signed-out visitors (and crawlers) always get the generic hero.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useHomeIntro() {
  const { user, loading } = useAuth();
  const [state, setState] = useState({ status: "pending" });
  useEffect(() => {
    if (loading) return undefined;
    if (!user) { setState({ status: "generic" }); return undefined; }
    let live = true;
    const giveUp = setTimeout(() => live && setState((s) => (s.status === "pending" ? { status: "generic" } : s)), 1500);
    api.get("/me/home-intro")
      .then(({ data }) => live && setState(data?.enabled && data.signedIn ? { status: "personal", ...data } : { status: "generic" }))
      .catch(() => live && setState({ status: "generic" }));
    return () => { live = false; clearTimeout(giveUp); };
  }, [user, loading]);
  return state;
}
